import logo_footer from "../img/logo_footer.png";
import {Popover, Row} from "antd";
import btn_mobile from "../img/btn_mobile.png";
import btn_email from "../img/btn_email.png";
import btn_location from "../img/btn_location.png";
import qrCode from "../img/meehoo.jpg";
import React from "react";
const tel = (
    <Row>
        <p>023-65392396</p>
        <p>13368396612(李老师)</p>
    </Row>
)

export const Footer10DataSource = {
    wrapper: { className: 'home-page-wrapper footer1-wrapper' },
    OverPack: { className: 'footer1 k4nhrqxxtep-editor_css', playScale: -1 },
    block: {
        className: 'home-page k4ni2gldh8-editor_css',
        gutter: 0,
        children: [
            {
                name: 'block0',
                xs: 4,
                md: 4,
                className: 'block',
                title: {
                    className: 'logo',
                    children: (
                        <div style={{cursor: 'default'}}>
                            <img src={logo_footer} alt='picture' width="125"/>
                        </div>
                    ),
                },
                childWrapper: {
                    className: 'slogan',
                    children: [
                        {
                            name: 'content0',
                            children: <div style={{cursor: 'default'}}>
                                <p>让智能化更简单易行</p>
                            </div>,
                        },
                    ],
                },
            },
            {
                name: 'block1',
                xs: 4,
                md: 4,
                className: 'block k4ni0pgvcji-editor_css',
                title: {
                    children: (
                        <>
                            <p>快速通道</p>
                        </>
                    ),
                },
                childWrapper: {
                    children: [
                        {
                            name: 'link0',
                            href: './product',
                            children: (
                                <>
                                    <p>产品服务</p>
                                </>
                            ),
                        },
                        {
                            name: 'link1',
                            href: './industrySolutions',
                            children: (
                                <>
                                    <p>行业应用</p>
                                </>
                            ),
                        },
                        {
                            name: 'link2',
                            href: './customerCase',
                            children: (
                                <>
                                    <p>客户案例</p>
                                </>
                            ),
                        },
                    ],
                },
            },
            {
                name: 'block2',
                xs: 4,
                md: 4,
                className: 'block',
                title: {
                    children: (
                        <>
                            <p>行业应用</p>
                        </>
                    ),
                },
                childWrapper: {
                    children: [
                        { href: './industrySolutions', name: '医疗领域', children: '医疗领域' },
                        { href: './industrySolutions', name: '教育领域', children: '教育领域' },
                        { href: './industrySolutions', name: '交通领域', children: '交通领域' },
                        // { href: './industrySolutions', name: 'link1', children: '消费服务' },
                        // { href: './industrySolutions', name: 'link1', children: '政府服务' },
                    ],
                },
            },
            {
                name: 'block3',
                xs: 4,
                md: 4,
                className: 'block',
                title: {
                    children: (
                        <>
                            <p>关于我们</p>
                        </>
                    ),
                },
                childWrapper: {
                    children: [
                        { href: './contactUs', name: 'link0', children: '企业介绍' },
                        { href: './contactUs', name: 'link1', children: '企业动态' },
                        { href: './contactUs', name: 'link1', children: '加入我们' },
                    ],
                },
            },
            {
                name: 'block~k4ni37w9mx7',
                xs: 4,
                md: 4,
                className: 'block',
                title: {
                    children: (
                        <>
                            <p>联系我们</p>
                        </>
                    ),
                },
                childWrapper: {
                    children: [
                        // { href: '#', name: 'link0', children: 'Ant Design' },
                        // { href: '#', name: 'link1', children: 'Ant Motion' },
                        { href: false, name: 'link1', children: (
                                <div>
                                    <Popover content={tel}>
                                        <img src={btn_mobile} alt='联系电话' width='25%' style={{marginRight:4}}/>
                                    </Popover>
                                    <Popover content="meehoo@meehoo.com">
                                        <img src={btn_email} alt='电子邮件' width='25%' style={{marginRight:4}} />
                                    </Popover>
                                    <Popover content="重庆市高新区西永微电子产业园区SOHO楼1703">
                                        <img src={btn_location} alt='地址' width='25%' />
                                    </Popover>
                                </div>
                            ) },
                    ],
                },
            },
         {
                name: 'block~k4ni3a32mlh',
                xs: 4,
                md: 4,
                className: 'block',
                title: {
                    children: ''
                    //     <div style={{textAlign: "center", cursor: 'default'}}>
                    //     <img src={qrCode} alt="qrCode" width={102}/>
                    //     <div style={{display: 'flex', justifyContent: 'center', fontSize: 14}}>
                    //         <p>关注官方微信</p>
                    //     </div>
                    // </div>,
                },
                childWrapper: {
                    children: [
                        {
                            // href: '#',
                            name: 'link0',
                            children: <div style={{textAlign: "center", cursor: 'default'}}>
                                <img src={qrCode} alt="qrCode" width={102}/>
                                <div style={{display: 'flex', justifyContent: 'center'}}>
                                    <p>关注官方微信</p>
                                </div>
                            </div>,
                        },
                        {
                            href: '#',
                            name: 'link1',
                            children: (
                                <>
                                    <p>
                                        <br />
                                    </p>
                                </>
                            ),
                        },
                    ],
                },
            },
        ],
    },
    copyrightWrapper: { className: 'copyright-wrapper k4njhotqwbf-editor_css' },
    copyrightPage: { className: 'home-page' },
    copyright: {
        className: 'copyright k4ni1btuave-editor_css',
        children: (
            <>
        <span>
          © 2012-2020&nbsp;&nbsp;重庆米弘科技有限公司&nbsp;&nbsp;版权所有&nbsp;&nbsp;渝ICP备16013717号
        </span>
            </>
        ),
    },
};
export default Footer10DataSource;